import { createApi } from "../axiosInstance";

const api = createApi("myBusiness");

const validateDownloadFormat = (params) => {
  if (params?.format && !["excel", "pdf"].includes(params.format)) {
    throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
  }
};

// Fresh implementation per mybusiness.md §3 — member CRUD only. Share Capital and Share Transfer
// are proxied/shared (see apis/MyBusiness/shareCapitalApi.js, shareTransferApi.js), not part of
// this module.
export const getMembers = (companyId) => api.get(`/company/${companyId}/member`);
// Alias so callers shared with apis/MyFPO/memberApi.js (which names this getMember, singular)
// can call one consistent name through useServiceApi() regardless of service.
export const getMember = getMembers;
export const getMemberById = (companyId, id) => api.get(`/company/${companyId}/member/${id}`);
export const createMember = (companyId, data) => api.post(`/company/${companyId}/member`, data);
export const updateMember = (companyId, id, data) => api.patch(`/company/${companyId}/member/${id}`, data);
export const deleteMemberById = (companyId, id) => api.delete(`/company/${companyId}/member/${id}`);
export const downloadMemberData = (companyId, params) => {
  validateDownloadFormat(params);
  return api.get(`/company/${companyId}/member/download`, { params, responseType: "blob" });
};
